import AxiosClient from './api'
import END_POINT from './constants'

export function getListItemById(payload) {
  const { idFolder, search, topLoad } = payload
  let params = '?'
  if (search) {
    params += `search=${search}&`
  }
  if (topLoad) {
    params += `limit=${topLoad}`
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.WEEKLY_AND_HEADCOUNT.FOLDER}/${idFolder}${params}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getDownloadUrlFolder(payload) {
  const { idFolder } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.WEEKLY_AND_HEADCOUNT.FOLDER}/${idFolder}/download`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getDownloadUrlFile(payload) {
  const { idFolder } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.WEEKLY_AND_HEADCOUNT.FILE}/${idFolder}/download`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function createFolder(payload) {
  const { userId, name, parentId, portfolioId } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.WEEKLY_AND_HEADCOUNT.FOLDER}`, {
      name,
      parent_id: parentId,
      portfolio_id: portfolioId,
      user_id: userId
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function moveFolder(payload) {
  const { userId, idItem, parentId } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.WEEKLY_AND_HEADCOUNT.FOLDER}/${idItem}/move`, {
      parent_id: parentId,
      user_id: userId
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function renameFolder(payload) {
  const { userId, idItem, name } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.WEEKLY_AND_HEADCOUNT.FOLDER}/${idItem}`, {
      name,
      user_id: userId
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function deleteFolder(payload) {
  const { id } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.delete(`${END_POINT.WEEKLY_AND_HEADCOUNT.FOLDER}/${id}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function uploadFile(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.WEEKLY_AND_HEADCOUNT.FILE}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function moveFile(payload) {
  const { idItem, folderId, userId } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.WEEKLY_AND_HEADCOUNT.FILE}/${idItem}/move`, {
      folder_id: folderId,
      user_id: userId
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function renameFile(payload) {
  const { idItem, name } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.WEEKLY_AND_HEADCOUNT.FILE}/${idItem}`, {
      name
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function deleteFile(payload) {
  const { id } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.delete(`${END_POINT.WEEKLY_AND_HEADCOUNT.FILE}/${id}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
